import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, FieldArray, FormSection } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';

import { DateField, SelectField, TextField } from './../../fields';
import { poExtend, maxValue, isValidDateTime, number, required } from '../../../utilities/validation';
import messages from '../../../text/messages';
import { getCurrencySymbol } from '../../../utilities/string';
import WizardButtons from '../../wizard/navigator/buttons';
import { isSameDay } from '../../../utilities/dateTime';

import './extend.css';
import { InviteForm } from '../index';
import { RoleDefinitions } from '../../../utilities/roles';
import Modal from '../../modal';

class ExtendForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true,
            modal: false,
            hms: []
        };

        this.toggleEdit = this.toggleEdit.bind(this);
        this.getHourlyPayFields = this.getHourlyPayFields.bind(this);
        this.getSoWPayFields = this.getSoWPayFields.bind(this);
        this.isFormDrty = this.isFormDirty.bind(this);
        this.renderProjects = this.renderProjects.bind(this);
        this.jobProject = this.jobProject.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleInvite = this.handleInvite.bind(this);
    }

    handleInvite(values) {
        const { inviteUser, change } = this.props;
        inviteUser(values, newUser => {
            change('hm_id', newUser.id);
            this.onClose();
        });
    }

    onOpen() {
        this.setState({ modal: true });
    }

    onClose() {
        this.setState({ modal: false });
    }
    getHourlyPayFields(rateCurrency) {
        const { disabled } = this.state;
        return (
            <div className="row">
                <div className="col-sm-6 col-xs-12">
                    <Field
                        name="rate"
                        validate={number}
                        component={TextField}
                        type="number"
                        extras={{ left: getCurrencySymbol(rateCurrency), right: <FormattedMessage {...messages.perHour} /> }}
                        placeholder={messages.payRate}
                        disabled={disabled}
                    />
                </div>
                <div className="col-sm-6 col-xs-12">
                    <Field
                        name="hours_per_week"
                        type="number"
                        validate={[number, maxValue(99)]}
                        component={TextField}
                        placeholder={messages.hoursPerWeek}
                        disabled={disabled}
                    />
                </div>
            </div>
        );
    }

    getSoWPayFields(rateCurrency) {
        const { disabled } = this.state;

        return (
            <div className="row">
                <div className="col-sm-6 col-xs-12">
                    <Field
                        name="contract_value"
                        validate={number}
                        type="number"
                        component={TextField}
                        extras={{ left: getCurrencySymbol(rateCurrency) }}
                        placeholder={messages.totalValue}
                        disabled={disabled}
                    />
                </div>
            </div>
        );
    }

    getPayField(worker) {
        return worker.pay_type === 'h' ? this.getHourlyPayFields(worker.rate_currency) : this.getSoWPayFields(worker.rate_currency);
    }

    toggleEdit() {
        this.setState({ disabled: !this.state.disabled });
    }

    isFormDirty() {
        const { fields, initialValues, end_date, start_date } = this.props;

        return Object.keys(fields || {}).some(key => {
            if (key === 'end_date' && !isSameDay(initialValues.end_date, end_date)) return true;
            if (key === 'start_date' && !isSameDay(initialValues.start_date, start_date)) return true;
            const getStringValue = obj => (obj ? JSON.stringify(obj) : '');
            if (!key.includes('.') && getStringValue(initialValues[key]) !== getStringValue(this.props[key])) return true;

            return false;
        });
    }

    jobProject(selectedProjests, project, index) {
        const { worker, projectsOptions } = this.props;
        const { disabled } = this.state;
        const { pay_type } = worker;
        const selectdProjestsIds = selectedProjests.getAll().map(p => p.project_id);
        const curretProject = selectedProjests.get(index);
        const options = projectsOptions.filter(p => p.value === curretProject.project_id || !selectdProjestsIds.includes(p.value));

        return (
            <FormSection name={project} key={project}>
                <div className="row">
                    <div className="col-xs-3">
                        <Field
                            name="project_id"
                            validate={required}
                            component={SelectField}
                            options={options}
                            placeholder={messages.project}
                            disabled={disabled}
                        />
                    </div>
                    <div className="col-xs-7">{pay_type !== 's' ? this.getHourlyPayFields() : this.getSoWPayFields()}</div>
                    {selectedProjests.length > 1 && (
                        <div className="col-xs-2">
                            <div className="text-primary clickable topOffset15" onClick={() => selectedProjests.remove(index)}>
                                <FormattedMessage {...messages.remove} />
                            </div>
                        </div>
                    )}
                </div>
            </FormSection>
        );
    }

    renderProjects({ fields }) {
        const { projectsOptions } = this.props;
        const { disabled } = this.state;

        const showAdd = fields.length !== projectsOptions.length && !disabled;

        return (
            <div className="topOffset15 group">
                {fields.map((project, index) => this.jobProject(fields, project, index))}
                {showAdd && (
                    <div className="row">
                        <div className="col-xs-12">
                            <div
                                className="text-primary clickable fit"
                                onClick={() => fields.push({ ...fields.get(fields.length - 1), project_id: undefined, hours_per_week: undefined })}
                            >
                                <FormattedMessage {...messages.addProject} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { onSubmit, handleSubmit, cancel, submitting, worker, start_date, end_date, users, clientId } = this.props;
        const { disabled, modal } = this.state;

        // don't allow edit if start was more than a week ago
        const oneWeekAgo = moment().subtract(7, 'days');
        const canEditStartDate = oneWeekAgo.isBefore(start_date);

        return (
            <div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-sm-6 col-xs-12">
                            <Field name={'user.first_name'} component={TextField} placeholder={messages.firstName} disabled={true} />
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <Field name="user.last_name" component={TextField} placeholder={messages.lastName} disabled={true} />
                        </div>

                        <div className="col-sm-6 col-xs-12">
                            <Field
                                name="start_date"
                                selectedDate={start_date}
                                validate={isValidDateTime}
                                component={DateField}
                                placeholder={messages.startDate}
                                disabled={!canEditStartDate}
                            />
                        </div>

                        <div className="col-sm-6 col-xs-12">
                            <Field
                                name="end_date"
                                selectedDate={end_date || null}
                                validate={isValidDateTime}
                                component={DateField}
                                placeholder={messages.endDate}
                            />
                        </div>

                        <div className="col-xs-12">
                            <div className="edit-button-wrapper">
                                <span>
                                    <FormattedMessage {...messages.assignmentDetails} />
                                </span>
                                <div className="toggle-edit" onClick={this.toggleEdit}>
                                    <i className={`material-icons ${this.state.disabled ? '' : 'text-primary'}`}>
                                        {this.state.disabled ? 'toggle_off' : 'toggle_on'}
                                    </i>
                                    <span>
                                        <FormattedMessage {...messages.edit} />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 col-xs-12">
                            <Field name="title" component={TextField} placeholder={messages.title} disabled={disabled} />
                        </div>

                        <div className="col-sm-6 col-xs-12">
                            <Field name="department" component={TextField} placeholder={messages.department} disabled={disabled} />
                        </div>

                        <div className="col-xs-9 col-sm-10">
                            <Field
                                name="hm_id"
                                component={SelectField}
                                options={users.map(user => ({ value: user.id, label: `${user.first_name} ${user.last_name}` }))}
                                placeholder={messages.reportingTo}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-xs-3 col-sm-2">
                            <button type="button" disabled={disabled} className="field-inline-button" onClick={this.onOpen}>
                                <FormattedMessage {...messages.add} />
                            </button>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <Field name="po_number" component={TextField} placeholder={messages.poNumber} disabled={disabled} />
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <Field
                                name="po_value"
                                validate={[number]}
                                component={TextField}
                                extras={{ left: getCurrencySymbol(worker.rate_currency) }}
                                placeholder={messages.poValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-xs-12">
                            <FieldArray name="projects" component={this.renderProjects} disabled={disabled} />
                        </div>
                    </div>

                    <WizardButtons
                        disabled={submitting || !this.isFormDirty()}
                        back={{ action: cancel, message: <FormattedMessage {...messages.cancel} /> }}
                        submit={{ message: <FormattedMessage {...messages.confirm} /> }}
                    />
                </form>
                <Modal
                    open={modal}
                    onClose={this.onClose}
                    managedClose
                    size="col-sm-8 col-sm-offset-2 col-xs-12"
                    title={<FormattedMessage {...(modal.type === 'address' ? messages.addAddress : messages.addUser)} />}
                >
                    <div className="row">
                        <InviteForm
                            onSubmit={this.handleInvite}
                            cancel={this.onClose}
                            tenantType={'client'}
                            initialValues={{ ref_id: clientId, ref_type: 'client' }}
                            availableRoles={[RoleDefinitions.Client, RoleDefinitions.ClientHiringManager]}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

ExtendForm.defaultProps = {
    worker: {},
    onSubmit: undefined,
    users: []
};

ExtendForm.propTypes = {
    worker: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    users: PropTypes.array
};

ExtendForm = reduxForm({
    form: 'extend-form',
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false,
    validate: poExtend
})(ExtendForm);

const selector = formValueSelector('extend-form');
const mapStateToProps = state => ({
    ...Object.keys((state.form['extend-form'] || { registeredFields: {} }).registeredFields).reduce(
        (props, key) => {
            if (!key.includes('.')) {
                props[key] = selector(state, key);
            }
            return props;
        },
        { fields: (state.form['extend-form'] || { registeredFields: {} }).registeredFields }
    ),
    role: state.identity.role
});

export default connect(mapStateToProps)(ExtendForm);



// WEBPACK FOOTER //
// ./src/components/forms/extend/index.jsx